import { Modal } from 'bootstrap'

function onOutside(
  elements: HTMLElement | HTMLElement[],
  eventNames: string | string[],
  callback: (evt: Event) => unknown
) {
  const abortController = new AbortController()
  const normElements = Array.isArray(elements) ? elements : [elements]
  const normEventNames = Array.isArray(eventNames) ? eventNames : [eventNames]

  const listener = (evt: Event) => {
    let inside = false
    for (const elem of normElements) {
      if (elem.contains(evt.target as HTMLElement)) {
        inside = true
        break
      }
    }
    if (!inside) {
      abortController.abort()
      callback(evt)
    }
  }

  for (const name of normEventNames) {
    document.addEventListener(name, listener, {
      signal: abortController.signal
    })
  }

  return abortController
}

const modals = Array.from(
  document.querySelectorAll<HTMLElement>('.vision-modal')
)

let outsideEventController: AbortController | undefined

for (const modal of modals) {
  const blockElement = modal.closest('.wp-block-yellowtree-vision')
  let backdropElem: HTMLElement | null | undefined
  if (blockElement) {
    backdropElem = blockElement.querySelector<HTMLElement>('.vision-backdrop')
  }

  const instance = Modal.getOrCreateInstance(modal)

  modal.addEventListener('show.bs.modal', () => {
    if (backdropElem) {
      backdropElem.style.display = ''
    }
    setTimeout(() => {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
      if (backdropElem) {
        backdropElem.classList.toggle('show', true)
      }
      outsideEventController = onOutside(modal, 'click', () => instance.hide())
    }, 0)
  })
  modal.addEventListener('hide.bs.modal', () => {
    if (outsideEventController) {
      outsideEventController.abort()
      outsideEventController = undefined
    }
    modal.classList.toggle('hide', true)
    if (backdropElem) {
      backdropElem.classList.toggle('show', false)
    }
  })
  modal.addEventListener('hidden.bs.modal', () => {
    modal.classList.toggle('hide', false)
    if (backdropElem) {
      setTimeout(() => {
        backdropElem.style.display = 'none'
      }, 0)
    }
  })
}
